import request from '@/utils/request'

/**
 * 获取仓库平面布局
 * @param {Object} params - 查询参数；lite=1 时仅库位树+盘查印记（移动端浏览）
 * @returns {Promise}
 */
export const getWarehouseLayout = (params) => {
  return request({
    url: '/api/warehouse-layout',
    method: 'get',
    params,
    // 大仓库 + 每库位明细预览，移动端易超过默认 20s；lite 模式通常很快
    timeout: params?.lite ? 60000 : 120000
  })
}

/**
 * 在仓库内按编码/名称定位库位（返回目标 + 面包屑，不拉库存预览）
 */
export const findWarehouseLocation = (params) => {
  return request({
    url: '/api/warehouse-layout/find-location',
    method: 'get',
    params,
    timeout: 30000
  })
}

/**
 * 按库位 ID 批量拉取库存预览/合计（当前层补明细）
 */
export const getWarehouseLocationCards = (params) => {
  return request({
    url: '/api/warehouse-layout/location-cards',
    method: 'get',
    params,
    timeout: 60000
  })
}

/**
 * 更新库位布局信息
 * @param {Object} data - 布局数据
 * @returns {Promise}
 */
export const updateLocationLayout = (data) => {
  return request({
    url: '/api/warehouse-layout/update-location',
    method: 'post',
    data
  })
}
